import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  FormsModule as AngularFormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { FoundationModule } from '@fundament/foundation/foundation.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DomModule } from '@lib/dom/dom.module';
import { IconsModule } from '../icons/icons.module';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DebounceTimeDirective } from './debounce-time.directive';
import { FormControlComponent } from './form-control/form-control.component';
import { FormErrorService } from './form-error.service';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { RequiredFieldHelpTextComponent } from './required-field-help-text/required-field-help-text.component';
import { SearchInputComponent } from './search-input/search-input.component';

@NgModule({
  imports: [
    AngularFormsModule,
    DomModule,
    CommonModule,
    FoundationModule,
    IconsModule,
    NgbDropdownModule,
    ReactiveFormsModule,
  ],
  declarations: [
    CheckboxComponent,
    DebounceTimeDirective,
    FormControlComponent,
    RadioButtonComponent,
    RequiredFieldHelpTextComponent,
    SearchInputComponent,
  ],
  providers: [FormErrorService],
  exports: [
    CheckboxComponent,
    DebounceTimeDirective,
    FormControlComponent,
    RadioButtonComponent,
    RequiredFieldHelpTextComponent,
    SearchInputComponent,
  ],
})
export class FormsModule {}
